(function () {

window.addEventListener('resize', function () {
  document.querySelectorAll('[id^="pcr-wrap-"]').forEach(function (wrap) {
    wrap._cachedWrapTop = null;
  });
});

  function initSection(wrap) {
   js
    var svgUrl     = wrap.dataset.svgUrl;
    var order      = wrap.dataset.pixelOrder;
    var duration   = parseInt(wrap.dataset.duration);
    var offset     = parseInt(wrap.dataset.offset);

    // DÉTECTION TABLETTE
    var isTablet = window.innerWidth >= 768 && window.innerWidth <= 1024;

    // TAILLE & POSITION ADAPTATIVES
    var size = parseInt(wrap.dataset.size);
    if (isTablet && wrap.dataset.sizeTablet) size = parseInt(wrap.dataset.sizeTablet);

    var posX = parseInt(wrap.dataset.posX);
    // (Ajoutez posXTablet ici si vous en avez un un jour)

    var posY = parseInt(wrap.dataset.posY);
    if (isTablet && wrap.dataset.posYTablet) posY = parseInt(wrap.dataset.posYTablet);



    var gridSize   = parseInt(wrap.dataset.gridSize) || 80;
    var canvas     = wrap.querySelector('canvas');
    var ctx        = canvas.getContext('2d');
    var pixels     = [];
    var lastCount  = -1;
    var rafPending = false;

    var sectionId   = wrap.id.replace('pcr-wrap-', '');
    var textEl      = document.getElementById('pcr-text-' + sectionId);
    var textOffset  = parseInt(wrap.dataset.textOffset) || 900;
    var textShown   = false;
    var blinkCount  = 0;
    var blinkMax    = 5;
    var blinkInterval = null;

    /* ── Reset canvas ── */
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    canvas.style.width  = '';
    canvas.style.height = '';

    /* ── Reset texte ── */
    if (textEl) {
      textEl.style.opacity = 0;
      textShown  = false;
      blinkCount = 0;
      if (blinkInterval) clearInterval(blinkInterval);
    }

    /* ── Nettoyer l'ancien listener scroll ── */
    if (wrap._pcrScrollHandler) {
      window.removeEventListener('scroll', wrap._pcrScrollHandler);
    }
wrap._cachedWrapTop = null;
    /* ── Clignotement rétro ── */
    function startBlink() {
      if (blinkInterval) clearInterval(blinkInterval);
      blinkCount = 0;
      textEl.style.opacity = 1;
      blinkInterval = setInterval(function () {
        blinkCount++;
        textEl.style.opacity = blinkCount % 2 === 0 ? 1 : 0;
        if (blinkCount >= blinkMax) {
          clearInterval(blinkInterval);
          textEl.style.opacity = 1;
        }
      }, 300);
    }

    /* ── Chargement image ── */
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {

      /* Pixelliser sur grille gridSize × gridSize */
      var off  = document.createElement('canvas');
      off.width  = gridSize;
      off.height = gridSize;
      var octx = off.getContext('2d');
      octx.drawImage(img, 0, 0, gridSize, gridSize);
      var data = octx.getImageData(0, 0, gridSize, gridSize).data;

      var raw = [];
      for (var i = 0; i < data.length; i += 4) {
        if (data[i + 3] > 10) {
          var idx = i / 4;
          raw.push({
            x: idx % gridSize,
            y: Math.floor(idx / gridSize),
            r: data[i],
            g: data[i + 1],
            b: data[i + 2],
            a: data[i + 3]
          });
        }
      }

      /* Tri selon l'ordre */
      var cx = gridSize / 2, cy = gridSize / 2;
      if (order === 'random') {
        for (var j = raw.length - 1; j > 0; j--) {
          var k = Math.floor(Math.random() * (j + 1));
          var tmp = raw[j]; raw[j] = raw[k]; raw[k] = tmp;
        }
      } else if (order === 'top_bottom') {
        raw.sort(function (a, b) { return a.y - b.y; });
      } else if (order === 'bottom_top') {
        raw.sort(function (a, b) { return b.y - a.y; });
      } else if (order === 'center_out') {
        raw.sort(function (a, b) {
          var da = (a.x - cx) * (a.x - cx) + (a.y - cy) * (a.y - cy);
          var db = (b.x - cx) * (b.x - cx) + (b.y - cy) * (b.y - cy);
          return da - db;
        });
      } else if (order === 'left_right') {
        raw.sort(function (a, b) { return a.x - b.x; });
      }

      pixels    = raw;
      lastCount = -1;

      /* Canvas dimensions */
      canvas.width  = gridSize;
      canvas.height = gridSize;

      var ref   = window.innerWidth * (size / 100);
      var ratio = (img.naturalWidth && img.naturalHeight)
                  ? img.naturalWidth / img.naturalHeight
                  : 1;
      var cssW  = ratio >= 1 ? ref : ref * ratio;
      var cssH  = ratio >= 1 ? ref / ratio : ref;

      canvas.style.width     = cssW + 'px';
      canvas.style.height    = cssH + 'px';
      canvas.style.left      = posX + '%';
      canvas.style.top       = posY + '%';
      canvas.style.transform = 'translate(-50%, -50%)';

  
       onScroll();
    };
    img.src = svgUrl;

    /* ── Scroll ── */
    function onScroll() {
      if (!rafPending) {
        rafPending = true;
        requestAnimationFrame(draw);
      }
    }

    wrap._pcrScrollHandler = onScroll;
    window.addEventListener('scroll', onScroll, { passive: true });

    /* ── Draw ── */
    function draw() {
      var wrapTop = wrap.getBoundingClientRect().top + window.scrollY;
      rafPending = false;
      if (!pixels.length) return;

     if (!wrap._cachedWrapTop) {
  wrap._cachedWrapTop = wrap.getBoundingClientRect().top + window.scrollY;
}
var wrapTop = wrap._cachedWrapTop;     
 var r       = Math.min(1, Math.max(0, (window.scrollY - wrapTop - offset) / duration));
      var count   = Math.floor(r * pixels.length);

      if (count === lastCount) return;
      lastCount = count;

      /* Texte — apparition après le personnage */
      if (textEl) {
        var textRatio = Math.min(1, Math.max(0, (window.scrollY - wrapTop - textOffset) / 100));
        if (textRatio >= 1 && !textShown) {
          textShown = true;
          startBlink();
        } else if (textRatio < 1) {
          textShown  = false;
          blinkCount = 0;
          if (blinkInterval) clearInterval(blinkInterval);
          textEl.style.opacity = 0;
        }
      }

      /* Dessin pixels */
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      var colorMap = {};
      for (var i = 0; i < count; i++) {
        var p   = pixels[i];
        var key = p.r + ',' + p.g + ',' + p.b + ',' + p.a;
        if (!colorMap[key]) {
          colorMap[key] = {
            style: 'rgba(' + p.r + ',' + p.g + ',' + p.b + ',' + (p.a / 255) + ')',
            pts: []
          };
        }
        colorMap[key].pts.push(p);
      }
      for (var c in colorMap) {
        ctx.fillStyle = colorMap[c].style;
        var pts = colorMap[c].pts;
        for (var j = 0; j < pts.length; j++) {
          ctx.fillRect(pts[j].x, pts[j].y, 1, 1);
        }
      }
    }
  }

  /* ── API publique vibes toggle ── */
  window.pcrReload = function (wrap) {
    var newUrl = wrap.dataset.svgUrl;
    if (!newUrl || newUrl === 'null') return;
     wrap._cachedWrapTop = null;
    initSection(wrap);
  };

  /* ── Init ── */
  function init() {
    document.querySelectorAll('[id^="pcr-wrap-"]').forEach(function (wrap) {
      if (!wrap.dataset.svgUrl || wrap.dataset.svgUrl === 'null') return;
      initSection(wrap);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
